<div class="m-2">
    <ngb-alert *ngIf="errorMessage" type="danger" (closed)="clearErrors()" style="margin-bottom: 8px;">
        {{ errorMessage }}
    </ngb-alert>
    <mat-card>
        <mat-card-content>
            <div style="display: flex; gap: 8px; padding: 1rem;">
                <button mat-flat-button color="primary" [matMenuTriggerFor]="application?.Co_Appl_Required === 'Yes' ? menu : primaryMenu">
                    Create Envelope 
                    <mat-icon iconPositionEnd>expand_more</mat-icon>
                </button>
                <button mat-flat-button color="primary" style="margin-left: 8px;" (click)="onRefresh()">
                    Refresh 
                </button>
                <!-- PRIMARY -->
                <mat-menu #menu="matMenu" class="custom-menu-item" style="width: 40%;">
                    <button mat-menu-item [matMenuTriggerFor]="primaryMenu">
                        <span>Primary</span>
                    </button>
                    <!-- CO-APPLICANT -->
                    <button mat-menu-item [matMenuTriggerFor]="coAppMenu">
                        <span>Co-Applicant</span>
                    </button>
                </mat-menu>
                <!-- PRIMARY -->
                <mat-menu #primaryMenu="matMenu">
                    <button mat-menu-item (click)="createEnvelope(_templateName?.CONSENT, appType?.PRIMARY)">
                        <span>Consent Form</span>
                    </button>
                    <button mat-menu-item *ngIf="primarySob.length > 0" [matMenuTriggerFor]="primarySobNames">
                        <span>Speak on Behalf</span>
                    </button>
                    <button mat-menu-item (click)="createEnvelope(_templateName?.AOB, appType?.PRIMARY)" >
                        <span>Apply on Behalf</span>
                    </button>                    
                    <button *ngIf="currentUser?._canCancelLPP && loanHasLpp" mat-menu-item (click)="createEnvelope(_templateName?.LPPCANCELLATION, appType?.PRIMARY)" >
                        <span>LPP Cancellation ({{docusignEnvelopeNLSDetails?.PolicyType}})</span>
                    </button>                    
                    <button *ngIf="currentUser?._canCreateLoanAmendment" mat-menu-item [matMenuTriggerFor]="primaryAmendmentTypes">
                        <span>Loan Amendment</span>
                    </button>
                </mat-menu>
                <!-- CO-APPLICANT -->
                <mat-menu #coAppMenu="matMenu">
                    <button mat-menu-item (click)="createEnvelope(_templateName?.CONSENT,appType?.COAPP)">
                        <span>Consent Form</span>
                    </button>
                    <button mat-menu-item *ngIf="coAppSob.length > 0" [matMenuTriggerFor]="coAppSobNames">
                        <span>Speak on Behalf</span>
                    </button>
                </mat-menu>
                <!-- PRIMARY -->    
                <mat-menu #primarySobNames="matMenu">
                    <button mat-menu-item *ngFor="let sob of primarySob" (click)="createSpeakOnBehalf(sob)">
                        {{sob?.Full_Name}} ({{sob?.Relation_to_Applicant}})
                    </button>
                </mat-menu>    
                <mat-menu #primaryAmendmentTypes="matMenu">
                    <button mat-menu-item *ngFor="let type of loanAmendmentTypes" (click)="createLoanAmendment(type)">
                        {{type}}
                    </button>
                </mat-menu>
                <!-- CO-APPLICANT -->       
                <mat-menu #coAppSobNames="matMenu">
                    <button mat-menu-item *ngFor="let sob of coAppSob" (click)="createSpeakOnBehalf(sob)">
                        {{sob?.Full_Name}} ({{sob?.Relation_to_Applicant}})
                    </button>
                </mat-menu>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card class="mt-4">
        <mat-card-content>
            <div style="padding: 1rem;">
                <div>
                    <mat-card-content class="scrollable-card-content" *ngIf="{ data: envelope$ | async } as vm">
                        <div *ngIf="isLoading || !vm.data" class="generating-preview">
                            <mat-spinner diameter="30" color="primary"></mat-spinner>
                            <p class="loading-text">Loading envelopes...</p>
                        </div>
                        <div *ngIf="!isLoading && vm.data && !vm.data.length" class="empty-state">
                            <mat-icon class="empty-state__icon">inbox</mat-icon>
                            <p class="empty-state__text">No envelopes</p>
                        </div>
                        <table *ngIf="!isLoading && vm.data?.length" style="overflow: auto;" mat-table [dataSource]="vm.data" class="flat-table mat-elevation-z0">
                            <ng-container matColumnDef="applicantName">
                                <th mat-header-cell *matHeaderCellDef> Name </th>
                                <td mat-cell *matCellDef="let element" 
                                    style="text-align: justify; cursor: pointer; color: rgb(21, 118, 209);"
                                    (click)="openPreviewWindow(element);">
                                    <span>{{ element?.name | uppercase }}</span>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="applicantType">
                                <th mat-header-cell *matHeaderCellDef> Type </th>
                                <td mat-cell *matCellDef="let element" style="text-align: justify;">
                                    <span>{{ element?.applicant_type | uppercase }}</span>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="clientEmail">
                                <th mat-header-cell *matHeaderCellDef> Email </th>
                                <td mat-cell *matCellDef="let element" style="text-align: justify;">
                                    <span>{{ element?.client_email }}</span>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="templateName">
                                <th mat-header-cell *matHeaderCellDef> Template </th>
                                <td mat-cell *matCellDef="let element" style="text-align: justify;">
                                    <span>{{ element?.templateRowId?.template_name?.replaceAll('_', ' ') | uppercase }}</span>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef> Status </th>
                                <td mat-cell *matCellDef="let element" style="text-align: justify;" >
                                    <span [ngClass]="element?.statusId?.status_name === 'completed' ? 'completed' : element?.statusId?.status_name === 'autoresponded' ? 'failed' : 'black'">{{ element?.statusId?.status_name === 'created' ? 'DRAFT' : element?.statusId?.status_name === 'autoresponded' ? 'DELIVERY FAILED' : element?.statusId?.status_name | uppercase }}</span>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="createdBy">
                                <th mat-header-cell *matHeaderCellDef> Created By </th>
                                <td mat-cell *matCellDef="let element" style="text-align: justify;">
                                    <span>{{ element?.createdBy?.full_name | uppercase }}</span>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="createdAt">
                                <th mat-header-cell *matHeaderCellDef> Created At </th>
                                <td mat-cell *matCellDef="let element" style="text-align: justify;">
                                    <span>{{ element?.created_at | date: 'yyyy/MM/dd, h:mm a' : 'UTC' }}</span>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="sentBy">
                                <th mat-header-cell *matHeaderCellDef> Sent By </th>
                                <td mat-cell *matCellDef="let element" style="text-align: justify;">
                                    <span>{{ element?.sentBy?.full_name | uppercase }}</span>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="sentAt">
                                <th mat-header-cell *matHeaderCellDef> Sent At </th>
                                <td mat-cell *matCellDef="let element" style="text-align: justify;">
                                    <span>{{ element?.sent_at | date: 'yyyy/MM/dd, h:mm a' : 'UTC' }}</span>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="actions">
                                <th mat-header-cell *matHeaderCellDef> Actions </th>
                                <td mat-cell *matCellDef="let row; let i = index">
                                <button mat-icon-button [matMenuTriggerFor]="actionMenu" [matMenuTriggerData]="{element: row, idx: i}">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="tableHeaders;"></tr>
                            <tr mat-row *matRowDef="let row; columns: tableHeaders; let i = index" (click)="onRowClick(row);" [class.active-row]="selectedActionIndex === i">
                            </tr>
                        </table>
                        <!-- Action Menu -->
                        <mat-menu #actionMenu="matMenu">
                            <ng-template let-element="element" matMenuContent>
                                <!-- <button mat-menu-item (click)="editEnvelopeAction(element)" [disabled]="element?.statusId?.status_name?.toLowerCase() !== 'created'">Edit</button> -->
                                <!-- <button mat-menu-item (click)="editEnvelopeAction(element)">Edit</button> -->
                                <button mat-menu-item (click)="sendEnvelopeAction(element)" 
                                [disabled]="element?.statusId?.status_name?.toLowerCase() !== 'created'" 
                                *ngIf="allowSend?.includes(element?.statusId?.status_name?.toLowerCase())">
                                    Send
                                </button>
                                <button mat-menu-item (click)="reSendEnvelopeAction(element)"
                                *ngIf="allowResend.includes(element?.statusId?.status_name?.toLowerCase())">
                                    Resend
                                </button>
                                <button mat-menu-item (click)="voidEnvelopeAction(element)"
                                *ngIf="allowVoid.includes(element?.statusId?.status_name?.toLowerCase())">
                                    Void
                                </button>
                                <button mat-menu-item (click)="deleteEnvelopeAction(element)" [disabled]="element?.statusId?.status_name?.toLowerCase() !== 'created'">Delete</button>
                                <button mat-menu-item (click)="uploadToWorkdrive(element)" [disabled]="!allowManualUpload?.includes(element?.statusId?.status_name?.toLowerCase())">Manual Upload</button>
                            </ng-template>
                        </mat-menu>
                    </mat-card-content>
                </div> 
            </div>
        </mat-card-content>
    </mat-card>
</div>
